module.exports = __webpack_public_path__ + "static/og-image-treble-gsm-lg-16bf3159af6fb02822933e0577aba6f8.png";